import { render, staticRenderFns } from "./InStoreAgingView.vue?vue&type=template&id=4f61cec0&scoped=true&"
import script from "./InStoreAgingView.vue?vue&type=script&lang=js&"
export * from "./InStoreAgingView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f61cec0",
  null
  
)

export default component.exports